import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import Back from '../../features/back/Back';
import { safeHTML } from '../../../utils/safeHTML';
import { useContent } from '../../../redux/reducer/content';
import { useModal } from '../../../hooks/useModal';
import { useLanguageControls } from '../../../hooks/useLanguageControls';
import { useAvailableLanguages } from '../../../hooks/useAvailableLanguages';
import { useCurrentStore } from '../../../hooks/useCurrentStore';
import { useTranslation, stores, languages } from '../../../translations';
import { copyright, copyrightParams } from '../../../constants/copyright';
import { languageNames } from '../../../constants/languages';
import { useRequests } from '../../../redux/reducer/requests';

const SelectLangModal = React.forwardRef(function SelectLangModal({ title, description }, ref) {
  const { state: appState } = useContent();
  const { id, closeModal } = useModal();
  const {
    authData: { isWeb },
  } = useRequests();
  const currentStore = useCurrentStore();
  const { changeLanguage, language } = useLanguageControls();
  const { t } = useTranslation();
  const currentLang = language;
  const availableLanguages = useAvailableLanguages();
  const currentLanguageImage = currentLang ? `/images/change-language/change-lang-${currentLang}.png` : '';
  const close = () => closeModal({ id });
  const hasMoreThanTwoLanguages = availableLanguages.length > 2;
  const hasLessOrEqualThanTwoLanguages = availableLanguages.length <= 2;
  const isRuLanguageNotKzStore = currentStore !== stores.kz && currentLang === languages.ru;

  return (
    <CustomModal isFullPage={true} animation={['fade']}>
      <div className={classNames(`select-lang-modal select-lang-modal_${appState}`)} ref={ref}>
        <div className='select-lang-modal__wrapper'>
          <Back
            className={classNames('select-lang-modal__back', {
              'select-lang-modal__back_app': !isWeb,
            })}
            onClick={close}
          />
          {currentLanguageImage && (
            <img
              className={classNames('select-lang-modal__img', {
                'select-lang-modal__img_arabic': isRuLanguageNotKzStore,
                'select-lang-modal__img_two-languages': hasLessOrEqualThanTwoLanguages,
                'select-lang-modal__img_app': !isWeb,
              })}
              src={currentLanguageImage}
              alt=''
            />
          )}
          <div className='select-lang-modal__content'>
            <div
              className={classNames('select-lang-modal__header', {
                'select-lang-modal__header-smaller-margin': hasMoreThanTwoLanguages,
              })}
            >
              <h2 className='select-lang-modal__title'>{safeHTML(title)}</h2>
              <div className='select-lang-modal__description'>{safeHTML(description)}</div>
            </div>
            <ul className='select-lang-modal__buttons-list'>
              {availableLanguages.map((lang) => (
                <li key={lang} className='select-lang-modal__list-item'>
                  <CustomButton
                    className={`select-lang-modal__button ${currentLang == lang && 'select-lang-modal__button_active'}`}
                    text={languageNames[lang]?.toUpperCase() ?? lang.toUpperCase()}
                    onClick={() => {
                      changeLanguage(lang);
                      close();
                    }}
                  />
                </li>
              ))}
            </ul>
            <div className='select-lang-modal__copyright'>{safeHTML(t(copyright, copyrightParams))}</div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
});

export default SelectLangModal;
SelectLangModal.propTypes = {};
